import { COMPANY_ROWS } from '../lib/company';

/**
 * Legal + banking requisites of ООО «FASTAGO», rendered as a definition list.
 * Reused on the /requisites page, in the bank-transfer block on /plans, at the
 * foot of the оферта/privacy pages and inside the printable invoice.
 */
export function RequisitesCard({ className = '' }: { className?: string }) {
  return (
    <dl
      className={`flex flex-col gap-3 rounded-lg border border-edge bg-bone-surface p-5 shadow-m-sm ${className}`}
    >
      {COMPANY_ROWS.map((row) => (
        <div key={row.label}>
          <dt className="text-[12px] font-medium text-ink-muted">{row.label}</dt>
          <dd className="mt-0.5 break-words text-[13.5px] font-semibold text-ink">
            {row.href ? (
              <a
                href={row.href}
                // Open web links in a new tab; mailto:/tel: stay in-context (no
                // stray blank tab) and let the OS handler take over.
                {...(row.href.startsWith('http')
                  ? { target: '_blank', rel: 'noopener noreferrer' }
                  : {})}
                className="text-brand transition-colors hover:text-brand-mid hover:underline"
              >
                {row.value}
              </a>
            ) : (
              row.value
            )}
          </dd>
        </div>
      ))}
    </dl>
  );
}
